import {IReactiveEventContentItem} from "../SchoolFeedContentItem";
import {getFormattedEventData, getTimezoneAbbr} from "../../../utils/CleversiteUtilities";
import FlatIcon from "../../utilities/FlatIcon";
import {modalStore} from "../../../stores/StoreLoader";
import {getContentItemIcon} from "../../blocks/TerracedGridTheme/FilesFoldersBlock/fileUtilities";
import ClickableLink from "../../utilities/ClickableLink";
import ImageComponent from "../../utilities/ImageComponent";
import React from "react";
import {isFile, isEvent} from "./utils";

export function ItemDetails(props) {
    let itemDetails;
    let formatted;

    if (props.itemObj.is_event && (props.itemObj as IReactiveEventContentItem).json_data.event) {
        formatted = getFormattedEventData(props.itemObj, undefined, "h:mma");
    }
    if (isEvent(props.itemObj)) {
        itemDetails = <div className={props.style}>
            {formatted?.timeStr && <div>
                <FlatIcon name={'flaticon-clock'}/>&nbsp;<span>{formatted.timeStr}</span>&nbsp;
                <span>{formatted.timeStr !== "All Day" && getTimezoneAbbr()}</span>
            </div>}
            {props.itemObj.json_data.event.location && <div role={"button"} onClick={() => modalStore.addModal({
                type: "schoolBlocksEvent",
                event: props.itemObj,
            })}>
                <FlatIcon name={'flaticon-map'}/> {props.itemObj.json_data.event.location}
            </div>}
        </div>
    } else if (isFile(props.itemObj)) {
        const iconUrl = getContentItemIcon(props.itemObj);
        itemDetails = <div className={props.style}>
            <ClickableLink href={props.itemObj.json_data.file.view_link}>
                <ImageComponent src={iconUrl} alt={"File Icon"}/>
                Click to View File
            </ClickableLink>
        </div>
    }

    return itemDetails;
}
